import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import FlatFeeMilestone from '../../entities/flatFeeMilestone';
import Invoice from '../../entities/invoice';
import Task from '../../entities/task';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteFlatFeeMilestone(): boolean {
return true;
}
export function collectFlatFeeMilestoneDeleteImpact(flatFeeMilestone: FlatFeeMilestone, context: DeleteImpactContext): void {
const key = 'flatFeeMilestone:' + flatFeeMilestone.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
if (!!flatFeeMilestone.invoiceId) {
addDeleteImpact(context, key, 'flatFeeMilestones*');
return;
}
const invoiceFlatFeeMilestoneIdsImpact = workingRows<Invoice>('invoice', findAll<Invoice>('invoices')).filter(invoiceRef => invoiceRef.flatFeeMilestoneIds?.includes(flatFeeMilestone.id) && !(invoiceRef.invoiceStatus === 'F'));
invoiceFlatFeeMilestoneIdsImpact.forEach(invoiceRef => addDeleteImpact(context, 'invoice:' + invoiceRef.id, 'invoices'));
const taskFlatFeeMilestoneBucketImpact = workingRows<Task>('task', findAll<Task>('tasks')).filter(taskRef => taskRef.flatFeeMilestoneBucket === flatFeeMilestone.id);
taskFlatFeeMilestoneBucketImpact.forEach(taskRef => addDeleteImpact(context, 'task:' + taskRef.id, 'tasks'));}
export function deleteImpactFlatFeeMilestone(flatFeeMilestone: FlatFeeMilestone): DeleteImpact {
const context = deleteImpactContext();
collectFlatFeeMilestoneDeleteImpact(flatFeeMilestone, context);
return deleteImpactCounts(context);
}
export function deleteFlatFeeMilestone(flatFeeMilestone: FlatFeeMilestone, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (cascade && (!!flatFeeMilestone.invoiceId)) return {status: 'blocked', impacts: [{value: 'flatFeeMilestones*', count: 1}]};
if (!cascade) {
if (!canDeleteFlatFeeMilestone()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectFlatFeeMilestoneDeleteImpact(flatFeeMilestone, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || flatFeeMilestone.id};
}
const key = 'flatFeeMilestone:' + flatFeeMilestone.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<Invoice>('invoice', [...store.getState().invoices.getMappingFor('flatFeeMilestoneIds', flatFeeMilestone.id)]).filter(invoiceTemp => invoiceTemp.flatFeeMilestoneIds?.includes(flatFeeMilestone.id)).forEach(invoiceTemp => {
const _invoice = ((_work.get('invoice:' + invoiceTemp.id) ?? invoiceTemp) as Invoice).clone();
if (_invoice.status === 'D') return;
if (_invoice.invoiceStatus === 'F') return;
_invoice.status = 'U';
_invoice.addedOn = newHRTimestamp();
_invoice.addedBy = getCurrentUserId();
_invoice.importSource = targetImportSource;
_invoice.importId = mergeId;
_invoice.flatFeeMilestoneIds = _invoice.flatFeeMilestoneIds?.filter(id => id !== flatFeeMilestone.id) || [];

_work.set('invoice:' + _invoice.id, _invoice);
dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice), 'invoice:' + _invoice.id);
});
workingRows<Task>('task', [...store.getState().tasks.getMappingFor('flatFeeMilestoneBucket', flatFeeMilestone.id)]).filter(taskTemp => taskTemp.flatFeeMilestoneBucket === flatFeeMilestone.id).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
if (_task.status === 'D') return;
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.flatFeeMilestoneBucket === flatFeeMilestone.id) {
_task.flatFeeMilestoneBucket = null;
_task.flatFeeBucket = null;
}
_work.set('task:' + _task.id, _task);
dispatch(Actions.TaskActions.saveTaskQueue(_task), 'task:' + _task.id);
});
const deleted = flatFeeMilestone.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.FlatFeeMilestoneActions.removeFlatFeeMilestoneQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceFlatFeeMilestone(flatFeeMilestone: FlatFeeMilestone, replaceWith: FlatFeeMilestone, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = flatFeeMilestone.id;}
const _work = workingSet();
workingRows<Invoice>('invoice', [...store.getState().invoices.getMappingFor('flatFeeMilestoneIds', flatFeeMilestone.id)]).filter(invoiceTemp => invoiceTemp.flatFeeMilestoneIds?.includes(flatFeeMilestone.id)).forEach(invoiceTemp => {
const _invoice = ((_work.get('invoice:' + invoiceTemp.id) ?? invoiceTemp) as Invoice).clone();
if (_invoice.status === 'D') return;
if (_invoice.invoiceStatus === 'F') return;
_invoice.status = 'U';
_invoice.addedOn = newHRTimestamp();
_invoice.addedBy = getCurrentUserId();
_invoice.importSource = targetImportSource;
_invoice.importId = mergeId;
_invoice.flatFeeMilestoneIds = _invoice.flatFeeMilestoneIds?.map(id => (id === flatFeeMilestone.id) ? replaceWith.id : id) || [];

_work.set('invoice:' + _invoice.id, _invoice);
store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
});
workingRows<Task>('task', [...store.getState().tasks.getMappingFor('flatFeeMilestoneBucket', flatFeeMilestone.id)]).filter(taskTemp => taskTemp.flatFeeMilestoneBucket === flatFeeMilestone.id).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
if (_task.status === 'D') return;
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.flatFeeMilestoneBucket === flatFeeMilestone.id) {
_task.flatFeeMilestoneBucket = replaceWith.id;
_task.flatFeeBucket = null;
}
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});



return flatFeeMilestone;
}
